(function (window, document, undefined) {
  "use strict";

  let logger = {},
    Vue,
    vodl_rs,
    user_loaded = false;

  const vodl_rs_class = ".vodl-reader-suggestions__wrapper";

  let username = "",
    useremail = "",
    userphone = "";

  /**
   * Initialize.
   * Check if Vue is available, get the widget data.
   */
  const _init = (element) => {
    if (element && element.getAttribute("data-loaded") === 'true') {
      return;
    }

    element.setAttribute("data-loaded", "true");
    if ( ! element.id ) {
      element.id = "reader-suggestions-unique-id-" + Math.random().toString(36).slice(2, 11);
    }

    // check login status and fetch credentials.
    const getUserPrefills = () => {
      let rmsso = window.RussMedia.SSO || false;
      if (rmsso.isLoggedIn()) {
        rmsso.getUserAsync().done((user) => {
          username = user.fullName;
          useremail = user.email;
          logger.log("user is logged in: ", user);
        });
      } else {
        logger.log("User is not logged in.");
      }
    };

    Vue = window.Vue || false;
    if (!Vue) {
      logger.log("No Vue!");
      return;
    } else {
      logger.log("Load Vue component.");
    }

    if (!user_loaded) {
      getUserPrefills();
    }

    let api_url = element.getAttribute("data-api-url");
    let api_key = element.getAttribute("data-api-key");
    let collapsed =
      "false" === element.getAttribute("data-collapsed") ? false : true;
    let phone_field =
      "false" === element.getAttribute("data-phone-field") ? false : true;
    let placeholders =
      "false" === element.getAttribute("data-placeholders") ? false : true;
    let variant =
      "slim" === element.getAttribute("data-variant") ? 'ReaderSuggestionsSlim' : 'ReaderSuggestions';

    let labels = element.getAttribute("data-labels") || "";
    if (labels) {
      labels = JSON.parse(labels)[0];
    }

    Vue.createApp({
      components: {
        ReaderSuggestions:
          window["@russmedia-frontend/nordstern-reader-suggestions"][variant],
      },
      data() {
        return {
          apiUrl: api_url,
          apiKey: api_key,
          collapsed: collapsed,
          displayPhoneField: phone_field,
          displayPlaceholders: placeholders,
          prefillEmail: useremail,
          prefillName: username,
          prefillPhone: userphone,
          labels: labels,
        };
      },
    }).mount("#" + element.id);
  };

  document.addEventListener("vodl_interaction_clicked", function (ev) {
    if (ev.detail?.interaction?.type === "tipp") {
      const readerSuggestions = document.querySelector(
        ".vodl-region-article__reader-suggestions"
      );

      if (readerSuggestions) {
        if (readerSuggestions.checkVisibility()) {
          readerSuggestions.style.display = "none";
        } else {
          readerSuggestions.style.display = "block";
        }
      }
    }
  });

  document.addEventListener("DOMContentLoaded", (e) => {
    try {
      logger = new window.RussMedia.Utils.Logger("[suggestions] ") || {
        log: function () {},
      };
    } catch (e) {
      logger = { log: function () {} };
    }

    vodl_rs = document.querySelectorAll(vodl_rs_class);
    if (vodl_rs.length < 1) {
      logger.log("No reader suggestions found.");
      return;
    }

    vodl_rs.forEach((element) => {
      _init(element);
    });
  });
})(window, document);
